import { render, staticRenderFns } from "./NavProfile.vue?vue&type=template&id=edb5ffc4&scoped=true&"
import script from "./NavProfile.vue?vue&type=script&lang=js&"
export * from "./NavProfile.vue?vue&type=script&lang=js&"
import style0 from "./NavProfile.vue?vue&type=style&index=0&id=edb5ffc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb5ffc4",
  null
  
)

export default component.exports